import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageHeader, Field } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const LIMITS = [["max_users", "Máx. usuários"], ["max_properties", "Máx. imóveis"], ["ai_calls_month", "Chamadas IA/mês"], ["whatsapp_numbers", "Números WhatsApp"]];

export default function AdminPlans() {
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/admin/plans").then((r) => setPlans(r.data)); }, []);
  const upd = (i, patch) => setPlans(plans.map((p, j) => (j === i ? { ...p, ...patch } : p)));
  const save = async (p) => { try { await api.put(`/admin/plans/${p.id}`, p); toast.success(`Plano ${p.name} salvo`); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="animate-in fade-in duration-500">
      <PageHeader title="Planos de assinatura" subtitle="Limites aplicados automaticamente. Use -1 para ilimitado. Estrutura pronta para conectar um gateway de pagamento." />
      <div className="grid lg:grid-cols-3 gap-6">
        {plans.map((p, i) => (
          <div key={p.id} className={`card-lux space-y-4 ${p.id === "profissional" ? "border-accent" : ""}`} data-testid={`plan-card-${p.id}`}>
            <div className="flex items-center justify-between"><Input className="font-heading font-bold text-lg w-40" value={p.name} onChange={(e) => upd(i, { name: e.target.value })} data-testid={`plan-name-${p.id}`} /><span className="text-[10px] uppercase tracking-wider font-mono text-muted-foreground">{p.id}</span></div>
            <Field label="Preço mensal (R$)"><Input type="number" value={p.price} onChange={(e) => upd(i, { price: Number(e.target.value) })} data-testid={`plan-price-${p.id}`} /></Field>
            <div className="grid grid-cols-2 gap-3">{LIMITS.map(([k, l]) => <Field key={k} label={l}><Input type="number" value={p.limits[k] ?? -1} onChange={(e) => upd(i, { limits: { ...p.limits, [k]: Number(e.target.value) } })} data-testid={`plan-${k}-${p.id}`} /></Field>)}</div>
            <Field label="Recursos (um por linha)"><Textarea rows={4} value={p.features.join("\n")} onChange={(e) => upd(i, { features: e.target.value.split("\n") })} data-testid={`plan-features-${p.id}`} /></Field>
            <Button onClick={() => save(p)} className="w-full" data-testid={`plan-save-${p.id}`}>Salvar</Button>
          </div>
        ))}
      </div>
    </div>
  );
}
